import { graphql } from '@search/gql-client/src';

export const AgentCreateCustomerMutation = graphql`
    mutation AgentCreateCustomerMutation(
        $name: String!
        $note: String
        $phone: String
        $email: String
    ) {
        businessCreateCustomer(
            name: $name,
            note: $note
            phone: $phone
            email: $email
        ) {
            id
            name
            note
            phone
            email
            created
            updated
        }
    }
`;
